import React, { useEffect, useState } from 'react'
import { Tabs } from 'antd'
import BalanceCardSM from '../dashboard/components/BalanceCardSM.jsx'
import { GetWalletApi } from '../../../api/request/wallet/withdraw.js';
import { GetPaymentGatewayApi } from '../../../api/request/wallet/deposit.js';
import DepositMobile from './deposit/DepositMobile.jsx';
import { WalletOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import WithdrawMobile from './withdraw/WithdrawMobile.jsx';
import { handleApiError } from '../../../utils/handleApiError.js';
import SegmentedComponent from '../../../components/segmented/Segmented.jsx';

export default function WalletPage() {
    const { userDetails } = useSelector(state => state?.user);
    const [selectedTab, setSelectedTab] = useState('Deposit');
    const [walletDetails, setWalletDetails] = useState(null);
    const [paymentGateways, setPaymentGateways] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState(null);

    const getPaymentGateway = async (type) => {
        setIsLoading(true);
        try {
            const { data } = await GetPaymentGatewayApi(type);
            if (data?.success) setPaymentGateways(data?.data);
        } catch (error) {
            handleApiError(error);
        } finally {
            setIsLoading(false);
        }
    }

    const getWalletDetails = async () => {
        setIsLoading(true);
        try {
            const params = { RuleType: 'Withdraw' }
            const { data } = await GetWalletApi(userDetails?._id, new URLSearchParams(params).toString());
            if (data?.success) setWalletDetails(data?.data)
        } catch (error) {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getPaymentGateway(1);
        getWalletDetails();
    }, []);

    useEffect(() => {
        if (selectedTab === "Withdraw") {
            getPaymentGateway(2);
        } else {
            getPaymentGateway(1);
        }
    }, [selectedTab]);

    const selectedPayment = paymentGateways.find((item) => item?.name === paymentMethod);

    const balanceCardsData = [

        // { id: 1, type: 'Wallet Balance', amount: walletDetails?.walletAmount || 0.00, color: 'bg-green-500', gradient: 'from-[#F0FDF4] to-[#ffff]', icon: <PlusCircleOutlined size={20} color='#fff' className='text-white' /> },
        { id: 1, type: 'Transaction Fees', amount: selectedPayment?.fee === 'Free' ? 'Free' : selectedPayment?.fee || 0.00, color: 'bg-green-500', gradient: 'from-[#F0FDF4] to-[#ffff]', icon: <PlusCircleOutlined size={20} color='#fff' className='text-white' /> },
        { id: 2, type: 'Processing Time', amount: selectedPayment?.processingTime || '0 H', color: 'bg-[#9810FA]', gradient: 'from-[#FAF5FF] to-[#ffff]', icon: <WalletOutlined size={20} color='#fff' className='text-white' /> },
        { id: 3, type: selectedTab === "Withdraw" ? 'Min Withdraw' : 'Min Deposit', amount: selectedTab === "Withdraw" ? walletDetails?.minAmount || 0.00 : selectedPayment?.minAmount || 0.00, color: 'bg-orange-500', gradient: 'from-[#FFF7ED] to-[#ffff]', icon: <WalletOutlined size={20} color='#fff' className='text-white' /> },
        { id: 4, type: selectedTab === "Withdraw" ? 'Max Withdraw' : 'Max Deposit', amount: selectedTab === "Withdraw" ? walletDetails?.maxAmount || 0.00 : selectedPayment?.maxAmount || 0.00, color: 'bg-red-500', gradient: 'from-[#FFEDED] to-[#ffff]', icon: <WalletOutlined size={20} color='#fff' className='text-white' /> }
    ];

    return (
        <div className="mobile-dashboard min-h-screen">
            {/* Deposit/Withdraw Toggle */}
            <div className="mb-6 rounded-lg shadow-sm">
                <SegmentedComponent
                    value={selectedTab}
                    setValue={setSelectedTab}
                    options={["Deposit", "Withdraw"]}
                    // className="custom-tabs mobile-account-tabs"
                    block={true}
                />
            </div>

            <div className="grid grid-cols-4 gap-3 my-6">
                {balanceCardsData.map((card, index) => (
                    <BalanceCardSM
                        key={card.id || index}
                        {...card}
                        className="text-center px-2 pb-1 py-2"
                        innerClassName="flex-col gap-2 !mb-0"
                        titleClass='!text-[8px] !leading-none !ml-0'
                        amountClass='!text-[10px]'
                    />
                ))}
            </div>

            {selectedTab === "Deposit" && <DepositMobile setPaymentMethod={setPaymentMethod} paymentMethod={paymentMethod} />}
            {selectedTab === "Withdraw" && <WithdrawMobile setPaymentMethod={setPaymentMethod} paymentMethod={paymentMethod} />}
        </div>
    )
}
